import React, { useState } from "react";
import {
  Col,
  Container,
  Row,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { Link } from "react-router-dom";
// import landingImage from "../../../assets/qrcode/hand-scanning-qr-code-restaurant.jpg";
import landingImage from "../../../assets/qrcode/Optimized-Landing.jpeg";

import landingImage2 from "../../../assets/qrcode/hand-scanning-qr-code-restaurant.jpg";
import landingQrImg from "../../../assets/qrcode/qr-code-software.jpg";
import landingProcessImg from "../../../assets/qrcode/myqrmenu_process.png";
import qrScanImg from "../../../assets/qrcode/qr1.png";
import qrScanImg2 from "../../../assets/qrcode/qr2.png";
import qrScanImg3 from "../../../assets/qrcode/qr3.png";
import "./HomePage.scss";

const HomePage = () => {
  const [open, setOpen] = useState("1");

  const toggle = (id) => {
    setOpen(open === id ? "" : id);
  };

  return (
    <React.Fragment>
      {/* Hero Section */}
      <section className="position-relative landing-hero-section">
        <img
          src={landingImage}
          className="w-100 h-100 object-cover landing-img"
          alt="Landing"
        />
        <div className="h-100 w-100 d-flex align-items-center justify-content-center position-absolute top-0 start-0">
          <Row className="w-100 text-center">
            <Col
              lg={8}
              className="h-100 w-100 d-flex flex-column align-items-center justify-content-center"
            >
              <div className="text-center" style={{ maxWidth: "50rem" }}>
                <h1 className="display-6 fw-bold mb-3 lh-base landing-h1">
                  <span className="text-success">Qr menu:</span> contactless &
                  eco-friendly menu for restaurants and hotels
                </h1>
                <p className="lead lh-base landing-p">
                  Build a digital menu accessible by a QR code easy and fast.
                  Order ready-to-use stickers right away!
                </p>
                <div className="d-flex gap-2 justify-content-center mt-4 landing-btn">
                  <Link
                    to="/register"
                    className="btn btn-primary d-flex justify-content-center align-items-center"
                  >
                    Get Started <i className="ri-arrow-right-line ms-1"></i>
                  </Link>
                  <Link
                    to="/pages-pricing"
                    className="btn btn-danger d-flex justify-content-center align-items-center"
                  >
                    View Plans <i className="ri-eye-line ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* What is QR Code Menu Section */}
      <section className="py-5 my-5 h-75">
        <Container>
          <Row>
            <Col lg={6} className="mb-4 mb-lg-0">
              <img
                src={landingImage}
                className="img-fluid rounded"
                alt="QR Menu"
              />
            </Col>
            <Col lg={6} className="text-black text-start">
              <h2>What is QR Code Menu?</h2>
              <p>
                QR Code menus are digital versions of physical menu cards at
                restaurants. Diners scan these QR Code menus to access the
                restaurant’s menu on their mobile phones. Each table has a
                unique QR code to ensure the restaurant can identify the
                position of the customer’s order.
              </p>
              <ul>
                <li>Order ready-to-use stickers right away!</li>
                <li>
                  Build a digital menu accessible by a QR code easy and fast.
                </li>
                <li>
                  Allow restaurants to update their menu in real-time without
                  reprinting.
                </li>
                <li>
                  Eliminate the need for physical menus, reducing printing
                  costs.
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Steps Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                  <AccordionHeader targetId="1">
                    Step 1: Register Your Restaurant
                  </AccordionHeader>
                  <AccordionBody accordionId="1">
                    Sign up on the QR menu platform by providing your
                    restaurant's name, details, and other relevant information
                    to get started.
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="2">
                    Step 2: Generate QR Code
                  </AccordionHeader>
                  <AccordionBody accordionId="2">
                    Use the platform's tools to generate a QR code linked to
                    your restaurant's digital menu.
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="3">
                    Step 3: Your Website is Presented to You
                  </AccordionHeader>
                  <AccordionBody accordionId="3">
                    Once the QR code is generated, the platform provides you
                    with a hosted website showcasing your menu.
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="4">
                    Step 4: Scan the QR and Visit the Website
                  </AccordionHeader>
                  <AccordionBody accordionId="4">
                    Print the QR code and place it on tables or stands in your
                    restaurant. Customers can scan it with their smartphones to
                    access your menu.
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
            </Col>
            <Col lg={6}>
              <img
                src={landingQrImg}
                className="img-fluid rounded"
                alt="QR Code"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Pricing Section */}
      <section className="py-5 bg-white">
        <Container>
          <h2 className="text-center mb-5">Pricing Plans</h2>
          <Row className="justify-content-center">
            {/* Basic Plan */}
            <Col lg={4} md={6} className="mb-4">
              <div className="card  shadow-lg">
                <div className="card-body text-start">
                  <div className="d-flex text-start gap-2">
                    <h5 className="card-title text-black fs-5 mt-1">
                      Basic Plan
                    </h5>
                    <div class="avatar-title  plan-rpice-circle bg-light rounded-circle text-primary">
                      <i class="fs-20 ri-book-mark-line"></i>
                    </div>
                  </div>
                  <p className="card-text text-muted">Starter</p>
                  <h2 className="fw-bold mb-3">
                    Free<span className="fs-6">/Month</span>
                  </h2>
                  <ul className="list-unstyled text-start mb-4 price-text-color fs-6">
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Free Theme
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Custom Logo/Banner
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      <strong>5/5 </strong>Categories Food/Drink
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      <strong>20/20</strong> Items Food/Drink
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      <strong>1/1</strong>Managers
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Most Visited Items
                    </li>
                    <li>
                      {" "}
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Business Themes
                    </li>
                    <li>
                      {" "}
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Premium Themes
                    </li>
                    <li>
                      {" "}
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Custom Domain
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Item Multiple Images
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Pages
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Order System Integration
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Customer Behaviors
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Remote Footer Ad
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Removes Sebs from QR
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Google Map Show
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Contact Messages
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      360 Pic
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Intro/Entranve/Surrounding Video
                    </li>
                  </ul>
                  <Link to="/register" className="btn btn-soft-primary w w-100">
                    Sign up free
                  </Link>
                </div>
              </div>
            </Col>

            {/* Pro Business Plan */}
            <Col lg={4} md={6} className="mb-4">
              <div className="card shadow-lg">
                <div className="card-body text-start right ribbon-box border shadow-none mb-lg-0">
                  <div className="d-flex text-start gap-2">
                    <h5 className="card-title text-black fs-5 mt-1">
                      SME Plan
                    </h5>
                    <div class="avatar-title plan-rpice-circle bg-light rounded-circle text-primary">
                      <i class="fs-20 ri-medal-line"></i>
                    </div>
                  </div>
                  <div className="ribbon-two ribbon-two-primary text-right">
                    <span>Popular</span>
                  </div>
                  <p className="card-text text-muted">Professional plans</p>
                  {/* <h2 className="fw-bold mb-3">
                    $29<span className="fs-6">/Month</span>
                  </h2> */}
                  <h3 className="fw-bold mb-3">
                    NRS.500<span className="fs-6">/Month</span>
                  </h3>
                  <ul className="list-unstyled  text-start mb-4 price-text-color fs-6">
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Free Theme
                    </li>
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Business Themes
                    </li>
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Custom Domain
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Custom Logo/Banner
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      5 Managers
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Order System Integration
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Most Visited Items
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Customer Behaviors
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Remote Footer Ad
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Google Map Show
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Contact Messages
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      <strong>2</strong>Intro/Entranve/Surrounding Video
                    </li>
                    <li>
                      {" "}
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Premium Themes
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      <strong>20/20</strong> Categories Food/Drink
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      <strong>100/100 </strong>Items Food/Drink
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Item Multiple Images
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Pages
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      Removes Sebs from QR
                    </li>
                    <li>
                      <i class="ri-close-circle-fill fs-15 align-middle text-danger me-2"></i>
                      360 Pic
                    </li>
                  </ul>
                  <Link to="/register" className="btn btn-primary w-100">
                    Get started
                  </Link>
                </div>
              </div>
            </Col>

            {/* Platinum Plan */}
            <Col lg={4} md={6} className="mb-4">
              <div className="card shadow-lg">
                <div className="card-body text-start">
                  <div className="d-flex text-start gap-2">
                    <h5 className="card-title text-start text-black mt-1 fs-5">
                      ERP Plan
                    </h5>
                    <div class="avatar-title plan-rpice-circle bg-light rounded-circle text-primary">
                      <i class="fs-20 ri-stack-line"></i>
                    </div>
                  </div>
                  <p className="card-text text-muted">Enterprise Businesses</p>
                  {/* <h2 className="fw-bold mb-3">
                    $39<span className="fs-6">/Month</span>
                  </h2> */}
                  <h3 className="fw-bold mb-3">
                    NRS.2000<span className="fs-6">/Month</span>
                  </h3>
                  <ul className="list-unstyled  text-start mb-4 price-text-color fs-6">
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Free Theme
                    </li>
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Business Themes
                    </li>
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Premium Themes
                    </li>
                    <li>
                      {" "}
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Custom Domain
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Custom Logo/Banner
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Unlimited Categories Food/Drink
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Unlimited Items Food/Drink
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Item Multiple Images
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Pages
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Unlimited Managers
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Order System Integration
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Most Visited Items
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Customer Behaviors
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Remote Footer Ad
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Removes Sebs from QR
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Google Map Show
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      Contact Messages
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      360 Pic
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-fill fs-15 align-middle text-success me-2"></i>
                      <strong>10</strong> Intro/Entranve/Surrounding Video
                    </li>
                  </ul>
                  <Link to="/register" className="btn btn-soft-primary  w-100">
                    Get started
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* How QR Menu Works Section */}
      <section className="py-5 h-auto">
        <Container>
          <Row className="d-flex">
            <Col className="d-flex flex-column align-items-center justify-content-center">
              <h1 className="text-center fs-1">How Does QR Menu Work?</h1>
              <p className="fs-2 text-center text-black w-75 fs-sm-5 qr-work">
                You can create your own menu with a self-designed QR code. Start
                a business with this contactless restaurant QR Code Menu Maker
                for each table location in your restaurant. Register, then fill
                out your restaurant’s details and create your menu. Then we
                connect it immediately to your QR code. We automatically attach
                it to your QR code. Once your brand new QR code is printed,
                place it where people can easily scan it. For example, on table
                tents, posters, your restaurant’s windows, or even on your
                napkins. With the help of this QR code digital menu builder,
                customers can scan the QR code and check the menu on their
                phones.
              </p>
              <img
                src={landingProcessImg}
                className="img-fluid d-block  rounded qr-process-img"
                alt="Process"
                style={{ width: "70%" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Best Way to Display Section */}
      <section className="py-5 bg-light h-100 w-100">
        <Container>
          <h2 className="text-center mb-5">Best Way to Display QR Code</h2>
          <Row className="justify-content-around display-qr">
            {[
              {
                img: qrScanImg,
                title: "QR Stickers & Label",
                description:
                  "Turn every surface into an opportunity to display your QR Code.",
              },
              {
                img: qrScanImg2,
                title: "QR Tabletop Inserts",
                description:
                  "Just slide the insert into the holder and start scanning.",
              },
              {
                img: qrScanImg3,
                title: "QR Table Tents",
                description: "Put the QR code with free-standing table tents.",
              },
            ].map((item, index) => (
              <Col
                lg={3}
                md={4}
                sm={6}
                className="mb-4 justify-content-center "
                key={index}
              >
                <img
                  src={item.img}
                  className="img-fluid rounded mb-3"
                  alt={`QR Display ${index + 1}`}
                />
                <h5 className="fw-bold text-start item-text">{item.title}</h5>
                <p className="text-black text-start item-text">
                  {item.description}
                </p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default HomePage;
